export const DEFAULT_DOCUMENTS_LOAD_LIMIT = 1000
export const DEFAULT_ALL_DOCUMENTS_PAGE_LIMIT = 1000
export const UNSCOPED_DOCUMENTS_LOAD_KEY = '__all__'
export const EMPTY_DOCUMENT_IDS: Array<string> = []
